import React, { useMemo } from 'react';
import { StructuredData } from 'components/SEO';
import { PublicSetCardAll } from 'store/services/sets/publicSetsApi';
import { buildCardUrl } from 'utils/cardUrlUtils';

interface SetItemListSchemaProps {
  cards: PublicSetCardAll[];
  setCode: string;
  setName: string;
  limit?: number;
}

export const SetItemListSchema: React.FC<SetItemListSchemaProps> = ({
  cards,
  setCode,
  setName,
  limit = 20,
}) => {
  const data = useMemo(() => {
    const items = cards.slice(0, limit).map((c, i) => ({
      '@type': 'ListItem',
      position: i + 1,
      url: `https://trademagic.gg${buildCardUrl({
        name: c.name,
        setCode,
        collectorNumber: c.collectorNumber,
        scryfallID: c.scryfallID,
      })}`,
      name: c.name,
    }));

    return {
      '@context': 'https://schema.org',
      '@type': 'ItemList',
      name: `Cards in ${setName}`,
      numberOfItems: cards.length,
      itemListOrder: 'https://schema.org/ItemListOrderAscending',
      itemListElement: items,
    };
  }, [cards, setCode, setName, limit]);

  if (cards.length === 0) return null;

  return <StructuredData data={data} />;
};
